// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0
import React from 'react';
import { HelpPanel } from '@cloudscape-design/components';

/* eslint-disable react/jsx-key */
export default [
  <HelpPanel
    header={<h2>Plantly</h2>}

  >
    <p>
      Not finding what you're looking for? Talk to the Plantly team to learn more!
    </p>
  </HelpPanel>,
];
/* eslint-enable react/jsx-key */
